import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// full list of importable shit: https://github.com/chrvadala/react-svg-pan-zoom/blob/HEAD/docs/documentation.md#api
import {
	fitToViewer,

	// constants
	POSITION_TOP,
	POSITION_RIGHT,
	POSITION_BOTTOM,
	POSITION_LEFT,
	ALIGN_LEFT,
	ALIGN_TOP,
} from 'react-svg-pan-zoom';

/* Code got copied from: https://github.com/chrvadala/react-svg-pan-zoom/blob/main/src/ui-toolbar/toolbar.jsx and adjusted for our needs */

const Toolbar = (props) => {
	const {
		tool,
		value,
		onChangeTool,
		onChangeValue,
		activeToolColor = '#1CA6FC',
		position = POSITION_RIGHT,
		SVGAlignX = ALIGN_LEFT,
		SVGAlignY = ALIGN_TOP,
		ToolbarItems,
		loadSVG,
		parentGUID,
		activeGUID,
		processViewLink,
	} = props;

	const { pathname } = useLocation();
	const navigate = useNavigate();

	const isHorizontal = [POSITION_TOP, POSITION_BOTTOM].indexOf(position) >= 0;

	// used for changing the tool
	const handleChangeTool = (event, newTool) => {
		onChangeTool(newTool);
		event.stopPropagation();
		event.preventDefault();
	};

	// used for fit to Viewer
	const handleFit = (event) => {
		onChangeValue(fitToViewer(value, SVGAlignX, SVGAlignY));
		event.stopPropagation();
		event.preventDefault();
	};

	const style = {
		// position
		position: 'absolute',
		transform: [POSITION_TOP, POSITION_BOTTOM].indexOf(position) >= 0 ? 'translate(-50%, 0px)' : 'none',
		top: [POSITION_LEFT, POSITION_RIGHT, POSITION_TOP].indexOf(position) >= 0 ? '5px' : 'unset',
		left: [POSITION_TOP, POSITION_BOTTOM].indexOf(position) >= 0 ? '50%' : POSITION_LEFT === position ? '5px' : 'unset',
		right: [POSITION_RIGHT].indexOf(position) >= 0 ? '5px' : 'unset',
		bottom: [POSITION_BOTTOM].indexOf(position) >= 0 ? '5px' : 'unset',

		// inner styling
		backgroundColor: 'rgba(19, 20, 22, 0.90)',
		borderRadius: '2px',
		display: 'flex',
		flexDirection: isHorizontal ? 'row' : 'column',
		padding: isHorizontal ? '1px 2px' : '2px 1px',
	};

	// custom toolbar
	return (
		<div style={style} role='toolbar'>
			<ToolbarItems
				tool={tool}
				activeToolColor={activeToolColor}
				position={position}
				handleChangeTool={handleChangeTool}
				handleFit={handleFit}
				loadSVG={loadSVG}
				parentGUID={parentGUID}
				activeGUID={activeGUID}
				pathname={pathname}
				processViewLink={processViewLink}
				navigate={navigate}
			/>
		</div>
	);
};

export default Toolbar;
